import { Directive, OnInit, Renderer2, ElementRef, Input } from '@angular/core';

import { CommonService } from 'src/app/services/common.service';

@Directive({
  selector: '[vrm-course-status-color]',
})
export class VrmCourseStatusColorDirective implements OnInit {
  @Input() status: string;

  constructor(private cService: CommonService, private renderer: Renderer2, private elementRef: ElementRef) {}

  ngOnInit() {
    if (this.status.toLowerCase() === 'complete') {
      return this.renderer.addClass(this.elementRef.nativeElement, 'agGridGreenTexts');
    }

    if (
      this.status.toLowerCase() === 'incomplete' ||
      (this.status.toLowerCase() === 'not started' &&
        this.cService?.userProfile?.userPermissions?.permDueDates === this.cService.permLevels.TRUE)
    ) {
      return this.renderer.addClass(this.elementRef.nativeElement, 'agGridAmberTexts');
    }

    return this.renderer.addClass(this.elementRef.nativeElement, 'agGridRedTexts');
  }
}
